import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, from, switchMap } from 'rxjs';

/**
 * Converts FormData requests to text/plain content
 */
export function uploadInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  if (req.url.includes('PutObject') && req.body instanceof FormData) {
    return from(processFormData(req.body, 'text/plain')).pipe(
      switchMap((textBlob) => {
        const convertedRequest = req.clone({
          headers: req.headers.set('Content-Type', 'text/plain'),
          body: textBlob,
        });
        return next(convertedRequest);
      })
    );
  }
  return next(req);
}

const processFormData = async (
  formData: FormData,
  contentType: string
): Promise<Blob> => {
  const textPromises: Promise<string>[] = [];

  formData.forEach((value, key) => {
    if (value instanceof File) {
      textPromises.push(readFileAsText(value));
    }
  });
  const textParts = await Promise.all(textPromises);
  const textContent = textParts.join('\n');
  return new Blob([textContent], { type: contentType });
};

const readFileAsText = async (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };
    reader.readAsText(file);
  });
};
